import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { flexRender } from "@tanstack/react-table";
import ProductSelectionDropdown from "./ProductSelectionDropdown";

export default function ProductTableHeader({
    table,
    selectedProducts,
    totalCount,
    products,
    setSelectedProducts,
    setPageSelections,
    handleSelectAll,
}: {
    table: any;
    selectedProducts: any;
    totalCount: number;
    products: any;
    setSelectedProducts: any;
    setPageSelections: any;
    handleSelectAll: any;
}) {
    return (
        <TableHeader>
            {table.getHeaderGroups().map((headerGroup: any) => (
                <TableRow key={headerGroup.id}>
                    {headerGroup.headers.map((header: any) => {
                        return (
                            <TableHead key={header.id}>
                                {header.isPlaceholder ? null : header.column
                                      .id === "select" ? (
                                    <ProductSelectionDropdown
                                        tableInstance={table}
                                        selectedProducts={selectedProducts}
                                        totalCount={totalCount}
                                        products={products}
                                        setSelectedProducts={
                                            setSelectedProducts
                                        }
                                        setPageSelections={setPageSelections}
                                        handleSelectAll={handleSelectAll}
                                    />
                                ) : (
                                    flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )
                                )}
                            </TableHead>
                        );
                    })}
                </TableRow>
            ))}
        </TableHeader>
    );
}
